/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Indexnow_Result_CountInputs */

const en_admin_indexnow_result_count = /** @type {(inputs: Admin_Indexnow_Result_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} URLs sent`)
};

/**
* | output |
* | --- |
* | "{count} URLs sent" |
*
* @param {Admin_Indexnow_Result_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_result_count = /** @type {((inputs: Admin_Indexnow_Result_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Result_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_result_count(inputs)
});
export { admin_indexnow_result_count as "admin.indexnow.result_count" }